<template>
  <div class="slider-holder">
    <flickity
      class="slides"
      ref="flickity"
      :options="flickityOptions">
      <info-block
        v-for="(item, index) in items"
        class="slider-info-block"
        :key="index"
        :content="item" />
    </flickity>
  </div>
</template>
<script>

import InfoBlock from '../components/InfoBlock'
import Flickity from 'vue-flickity'

export default {
  components: {
    InfoBlock,
    Flickity
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        imagesLoaded: true,
        resize: true
      }
    }
  },
  mounted () {
    // fix for the flickity slider height
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }
}
</script>
<style lang="scss">
  .slider-holder {
    .flickity-page-dots {
      bottom: -40px;
      .dot {
        background-color: $nos-op3-white;
        opacity: 1;
        width: 13px;
        height: 13px;
        margin: 0 5px;
        will-change: opacity;
        transition: opacity 200ms ease;
        position: relative;

        &.is-selected {
          background-color: $nos-op3-red;
        }
      }
    }
    .slider-info-block {
      width: 80%;
      max-width: 450px;
      padding: 0 10px;
      opacity: 0.4;
      transition: opacity 0.8s, transform 0.8s;
      transform: scale(0.9, 0.9);

      &.is-selected {
        opacity: 1;
        transform: scale(1, 1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InfoBlockSlider.vue